<div class="mx-6 mb-4">
	<!-- TODO: add comego-box + recordtoolbar-->
	<div
		*ngIf="viewDate$status | async as vd"
		class="flex space-x-1 mb-4"
	>
		<button
			(click)="prev()"
			[disabled]="(!vd.isFuture && !vd.isValidRange)"
			[matTooltip]="'utils.older' | translate"
			class="mat-button-square !rounded-lg"
			fxHide.lt-sm
			mat-button
		>
			<mat-icon>chevron_left</mat-icon>
		</button>
		<button
			(click)="dayPickerPopover.toggle()"
			[matTooltip]="'utils.pickTimeRange' | translate"
			[satPopoverAnchor]="dayPickerPopover"
			class="mt-1 h-10 flex items-center justify-start gap-1 !px-0"
			mat-button
		>
			<span>({{ 'timer.calendar.kw' | translate: { value: vd.start | formatDate: 'I' } }})</span>
		</button>
		<button
			(click)="next()"
			[disabled]="(vd.isFuture && !vd.isValidRange)"
			[matTooltip]="'utils.newer' | translate"
			class="mat-button-square !rounded-lg"
			fxHide.lt-sm
			mat-button
		>
			<mat-icon>chevron_right</mat-icon>
		</button>
		<button
			(click)="today()"
			[disabled]="vd.sameWeek"
			[matTooltip]="'timer.calendar.today' | translate"
			fxHide.lt-sm
			mat-icon-button
		>
			<mat-icon>today</mat-icon>
		</button>
	</div>

	<ng-container *ngIf="{ comego: times$listView | async } as views">
		<ng-container
			*ngTemplateOutlet="views.comego ? itemListView : itemListNoItems; context: { $implicit: views.comego }"
		></ng-container>
	</ng-container>
</div>

<tg-day-picker-popover
	(viewDateChange)="range.update($event)"
	[max]="maxRangeStart"
	[min]="minRangeStart"
	[viewDate]="range.value$ | async"
	#dayPickerPopover
	rangeType="week"
></tg-day-picker-popover>

<ng-template #itemListNoItems>
	<div class="pos-relative group-wrap rounded-inherit flex h-40 flex-col items-center justify-center space-y-4">
		<p translate>utils.noitems</p>
	</div>
</ng-template>
<ng-template
	#itemListView
	let-list
>
	<div class="pos-relative group-wrap rounded-inherit flex flex-col space-y-4">
		<ng-container *ngFor="let view of list; let lastList = last; let firstList = first; trackBy: trackId">
			<mat-card class="pos-relative group-wrap rounded">
				<mat-card-title-group class="group-header flex flex-wrap pb-2 items-start">
					<mat-card-title class="group-date min-w-[130px]">{{
						view.date | dfnsFormat: 'iiii'
					}}</mat-card-title>
					<mat-card-subtitle class="group-date-full min-w-[130px]">{{
						view.date | formatDate: 'PP'
					}}</mat-card-subtitle>
					<div
						*ngIf="view.comego?.length"
						class="flex min-h-10 min-w-0 flex-auto items-start min-[600px]:hidden"
					>
						<div class="flex-auto min-w-0"></div>
						<div class="h-10 w-10 min-w-10 shrink-0 flex items-center justify-center">
							<ng-container *ngIf="view.meta.workinghoursErrors as werrsXs">
								<div
									[matTooltipTemplate]="whErrorTooltip"
									[matTooltipTemplateContext]="{ errors: werrsXs }"
									[ngClass]="(isAMPM$ | async) ? 'max-[425px]:flex' : 'max-[375px]:flex'"
									class="entry-warning-badge h-8 w-8 shrink-0 items-center justify-center rounded-full hidden"
									matTooltip
								>
									<mat-icon class="entry-warning-badge-icon">warning</mat-icon>
								</div>
							</ng-container>
						</div>
						<div class="entry-buttons flex flex-shrink-0">
							<button
								(click)="editDay(view)"
								[disabled]="!isItemEditable(view.comego[0])"
								*ngIf="view.editable"
								mat-icon-button
							>
								<mat-icon>edit</mat-icon>
							</button>
							<button
								(click)="deleteDay(view, confirmDeleteDialog)"
								[disabled]="!isItemEditable(view.comego[0])"
								*ngIf="view.deleteable"
								mat-icon-button
							>
								<mat-icon>delete</mat-icon>
							</button>
						</div>
					</div>
					<div
						[class.has-absence]="!!view.sum.absence"
						class="group-header-actions ml-auto flex flex-shrink-0 flex-wrap items-center justify-end gap-2 max-[470px]:gap-1"
					>
						<div
							class="comego-status-row mat-bd-5 flex h-10 flex-shrink-0 items-center rounded-lg px-4 max-[470px]:px-2"
						>
							<ng-container *ngIf="view.sum.absence as absence">
								<div
									[matTooltip]="'comego.types.absence' | translate"
									class="flex items-center gap-2 max-[470px]:gap-1"
								>
									<mat-icon
										class="mat-icon-sm text-[18px] leading-none max-[470px]:text-[16px]"
										inline
										>{{
											iconMap['absence']
										}}</mat-icon
									>
									<div class="flex min-w-0 flex-col mt-1 max-[470px]:mt-0.5">
										<div class="text-md font-semibold leading-none max-[470px]:text-sm">
											{{ absence | parseMsAsDuration }}
										</div>
									</div>
								</div>
								<div class="mx-3 max-[470px]:mx-1.5">
									<mat-divider
										class="h-8 rotate-6 max-[470px]:h-6"
										inset
										vertical
									></mat-divider>
								</div>
							</ng-container>
							<div
								[matTooltip]="'comego.types.work' | translate"
								class="flex items-center gap-2 max-[470px]:gap-1"
							>
								<mat-icon
									class="mat-icon-sm text-[18px] leading-none max-[470px]:text-[16px]"
									inline
									>{{
										iconMap['work']
									}}</mat-icon
								>
								<div class="flex min-w-0 flex-col mt-1 max-[470px]:mt-0.5">
									<div class="text-md font-semibold leading-none max-[470px]:text-sm">
										{{
											((view.schedule?.usage - (view.sum.absence ?? 0)) ?? view.sum.work) | parseMsAsDuration
										}}
									</div>
								</div>
							</div>
							<div class="mx-3 max-[470px]:mx-1.5">
								<mat-divider
									class="h-8 rotate-6 max-[470px]:h-6"
									inset
									vertical
								></mat-divider>
							</div>
							<div
								[matTooltip]="(view.sum.pause - view.sum.realBreak) > 0
									? ('comego.breakQualifyAs' | translate: {
										shortBreak: view.sum.realBreak | parseMsAsDuration,
										break: view.sum.pause | parseMsAsDuration
									}) : 'comego.types.pause_short' | translate "
								class="flex items-center gap-2 max-[470px]:gap-1"
							>
								<mat-icon
									class="mat-icon-sm text-[18px] leading-none max-[470px]:text-[16px]"
									inline
									>{{
										iconMap['pause']
									}}</mat-icon
								>
								<div class="flex min-w-0 flex-col mt-1 max-[470px]:mt-0.5">
									<div class="text-md font-semibold leading-none max-[470px]:text-sm">
										{{ view.sum.pause | parseMsAsDuration }}
									</div>
								</div>
							</div>
						</div>
						@if(scheduleEnabled$ | async) {
						<ng-container *ngIf="view.schedule as sched">
							<div
								class="schedule-difference-box mat-bd-5 flex h-10 flex-shrink-0 items-center gap-2 rounded-lg px-3 max-[470px]:gap-1 max-[470px]:px-2"
							>
								<div class="flex flex-col space-y-0.5 min-w-0">
									<ng-container *ngIf="view.isPending; else plannedView">
										<div
											[matTooltip]="(sched.pending <= 0.0 ? 'schedules.dashboard.difference' : 'schedules.dashboard.future') | translate"
										>
											<div
												[ngClass]="sched.pending > 0.0 && 'mat-text-primary'"
												*ngIf="sched.pending >= 0; else pendingOvertimeText"
												class="text-md font-semibold leading-none mt-1 w-12 text-center max-[470px]:mt-0.5 max-[470px]:w-10 max-[470px]:text-sm"
											>
												{{ sched.pending | parseMsAsDuration }}
											</div>
										</div>
										<ng-template #pendingOvertimeText>
											<div
												class="text-success text-md font-semibold leading-none mt-1 w-12 text-center max-[470px]:mt-0.5 max-[470px]:w-10 max-[470px]:text-sm"
											>
												{{ '+' + (sched.pending | parseMsAsDuration) }}
											</div>
										</ng-template>
									</ng-container>
									<ng-template #plannedView>
										<ng-container *ngIf="{ value: sched.usage - sched.cap } as diff">
											<div [matTooltip]="'schedules.dashboard.difference' | translate">
												<div
													[ngClass]="diff.value < 0 ? 'text-warn' : diff.value > 0 ? 'text-success' : null"
													class="text-md font-semibold leading-none mt-1 w-12 text-center max-[470px]:mt-0.5 max-[470px]:w-10 max-[470px]:text-sm"
												>
													{{
														(diff.value < 0 ? '-' : diff.value > 0 ? '+' : '') + (diff.value | parseMsAsDuration)
													}}
												</div>
											</div>
										</ng-container>
									</ng-template>
								</div>
								<div
									class="mat-circle-card schedule-difference-spinner-wrap flex-shrink-0 max-[470px]:scale-75 max-[470px]:origin-center"
								>
									<mat-progress-spinner
										[color]="view.isPending ? (sched.graphState === 'accent' ? 'primary' : sched.graphState) : sched.graphState"
										[diameter]="20"
										[value]="sched.percent * 100 | clamp: 0 : 100"
										class="with-back-spinner"
										strokeWidth="3"
									></mat-progress-spinner>
								</div>
							</div>
						</ng-container>
						}
					</div>
				</mat-card-title-group>
				<mat-card-content>
					<div class="flex flex-row space-y-2">
						<div class="entries-container">
							<ng-container
								*ngFor="let item of view.comego; let last = last; let first = first; let index = index; trackBy: trackId"
							>
								<div class="relative flex items-start space-x-2">
									<ng-container
										*ngTemplateOutlet="
						dotView;
						context: {
						$implicit: item,
						last,
						first,
						isBetween: !last && !first,
						}
					"
									></ng-container>
									<ng-container
										*ngTemplateOutlet="
						itemView;
						context: {
						$implicit: item,
						editable: view.editable,
						deleteable: view.deleteable,
						view: view,
						last,
						first,
						isBetween: !last && !first,
						meta: item.meta,
						isFirstEntry: index === 0,
						}
					"
									></ng-container>
								</div>
							</ng-container>
						</div>
						<div>
							<ng-container
								*ngFor="let item of view.projectTimes; let last = last; let first = first; let index = index; trackBy: trackId"
							> </ng-container>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</ng-container>
	</div>
</ng-template>
<ng-template
	#eventView
	let-events
>
	<div class="relative flex flex-col space-y-2 pt-2">
		<ng-container *ngFor="let item of events; let last = last; let first = first; trackBy: trackId">
			<div class="flex items-start space-x-2">
				<div
					class="bg-primary-8 z-[2] mt-0.5 flex size-8 items-center justify-center rounded-full p-2 leading-8 text-white"
				>
					<mat-icon
						class="text-center"
						inline
					>
						access_time
					</mat-icon>
				</div>
				<ng-container
					*ngTemplateOutlet="
            itemView;
            context: {
              $implicit: item,
              last,
              first,
              isBetween: !last && !first,
              meta: item.meta,
            }
          "
				></ng-container>
			</div>
		</ng-container>
	</div>
</ng-template>
<ng-template
	#dotView
	let-between="isBetween"
	let-first="first"
	let-item
	let-last="last"
	let-line="line"
>
	<div class="flex h-12 w-8 xs:w-12 flex-shrink-0 items-center justify-center">
		<div
			*ngIf="line === 'top' || !first"
			class="absolute bottom-[20px] z-[1] flex h-full w-10 items-start justify-center"
		>
			<div class="h-full w-[2px] bg-gray-300 dark:bg-[#3E3E3E]"></div>
		</div>
		<div
			[ngClass]="
        item.type === 'work'
          ? 'size-8 p-2 leading-8 border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200'
          : item.type === 'absence'
            ? 'size-8 p-2 leading-8 border  border-violet-400 bg-violet-800/90 dark:bg-violet-800/60  text-violet-100'
            : 'size-6 p-0 leading-6 dark:bg-neutral-600 bg-neutral-600/80'
      "
			*ngIf="!line && item.meta"
			class="z-[2] flex items-center justify-center rounded-full text-neutral-100"
		>
			<mat-icon
				class="text-center"
				inline
			>
				{{ iconMap[item.meta.type] }}
			</mat-icon>
		</div>
		<div
			*ngIf="line === 'bottom' || !last"
			class="absolute top-[20px] z-[1] flex h-full w-10 items-start justify-center"
		>
			<div class="h-full w-[2px] bg-gray-300 dark:bg-[#3E3E3E]"></div>
		</div>
	</div>
</ng-template>
<ng-template
	#itemView
	let-deleteable="deleteable"
	let-editable="editable"
	let-isFirstEntry="isFirstEntry"
	let-item
	let-meta="meta"
	let-view="view"
>
	<div class="entry-row group flex flex-shrink-0 items-center justify-between space-x-2 gap-2">
		<div
			(click)="isItemEditable(item) && editable && editDay(view)"
			[ngClass]="{ 'group-hover:mat-bg-5 cursor-pointer': editable }"
			class="flex flex-col rounded-lg px-2 py-1.5 lg:flex-row lg:items-center lg:justify-between lg:space-x-6 lg:wflex-[0_0_480px]"
		>
			<div
				[matTooltip]="item.name"
				[matTooltipDisabled]="!item.name || item.name.length < 30"
				[matTooltipOptions]="{ delay: [500, 0] }"
				class="mb-0.5 ml-4 hidden lg:flex flex-col"
			>
				<span class="font-semibold leading-snug">{{ item | workinghoursType }}</span>
				<span
					*ngIf="item.name as desc"
					class="mat-hint leading-snug"
					>{{
						desc | truncate: 30
					}}</span
				>
			</div>
			<div
				[ngClass]="(isAMPM$ | async) ? 'w-[270px]' : 'w-[210px]'"
				class="mat-bd-5 flex h-10 flex-shrink-0 items-center rounded-lg px-4"
			>
				<div class="entry-time-col flex flex-col justify-end space-y-0.5">
					<div
						class="entry-time-label mat-hint text-sm leading-none"
						translate
					>
						timer.time.start
					</div>
					<div class="entry-time-value text-md font-semibold leading-none">
						{{ item.start | formatDate: 'time' : null : item.timeZone }}
					</div>
				</div>
				<div class="entry-time-sep-col entry-time-col mx-3 flex flex-col justify-end items-center space-y-0.5">
					<div class="entry-time-label mat-hint text-sm leading-none">&#8203;</div>
					<div class="entry-time-value text-md font-semibold leading-none">-</div>
				</div>
				<div class="entry-time-col flex flex-col justify-end space-y-0.5">
					<div
						class="entry-time-label mat-hint text-sm leading-none"
						translate
					>
						timer.time.end
					</div>
					<ng-container *ngIf="!item.meta.recording; else recordingText">
						<div class="entry-time-value text-md font-semibold leading-none">
							{{ item.end | formatDate: 'time' : null : item.timeZone }}
						</div>
					</ng-container>
				</div>
				<ng-container *ngIf="!item.meta.recording">
					<div class="mx-3">
						<mat-divider
							class="h-8 rotate-6"
							inset
							vertical
						></mat-divider>
					</div>
					<div class="entry-time-col flex flex-col justify-end space-y-0.5">
						<div
							class="entry-time-label mat-hint text-sm leading-none"
							translate
						>
							timer.time.duration
						</div>
						<div class="entry-time-value text-md font-semibold leading-none">
							{{ (item.end - item.start) / 1000 | parseMsAsDuration: false : true }}
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<div
			[ngClass]="(isAMPM$ | async) ? 'max-[425px]:hidden' : 'max-[375px]:hidden'"
			class="flex max-[600px]:!mx-0 gap-2"
		>
			<ng-container *ngIf="meta.errors?.length">
				<div class="h-10 w-10 flex items-center justify-center">
					<div
						[matTooltipTemplate]="whErrorTooltip"
						[matTooltipTemplateContext]="{ errors: meta.errors }"
						class="entry-warning-badge flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
						matTooltip
					>
						<mat-icon class="entry-warning-badge-icon">warning</mat-icon>
					</div>
				</div>
			</ng-container>
			<div
				*ngIf="isFirstEntry"
				class="entry-buttons flex opacity-0 gap-2"
				fxHide.lt-sm
			>
				<button
					(click.stop)="editDay(view)"
					[disabled]="!isItemEditable(item)"
					*ngIf="editable"
					mat-icon-button
				>
					<mat-icon>edit</mat-icon>
				</button>
				<button
					(click.stop)="deleteDay(view, confirmDeleteDialog)"
					[disabled]="!isItemEditable(item)"
					*ngIf="deleteable"
					mat-icon-button
				>
					<mat-icon>delete</mat-icon>
				</button>
			</div>
		</div>
		<div
			class="flex-auto"
			fxHide.lt-sm
		></div>
	</div>
</ng-template>
<ng-template
	#scheduleView
	let-sched
>
	<div
		[matTooltipTemplate]="scheduleTooltip"
		[matTooltipTemplateContext]="{ $implicit: sched }"
		class="mat-typography mat-bg-5-hover grid h-12 grid-cols-[1fr_28px] items-center gap-x-6 rounded-lg px-4"
		matTooltip
	>
		<div class="flex flex-col text-right text-sm">
			<span>{{ sched.usage | parseMsAsDuration }}</span>
			<span>{{ sched.cap | parseMsAsDuration }}</span>
		</div>
		<div class="mat-circle-card">
			<mat-progress-spinner
				[color]="sched.graphState"
				[diameter]="20"
				[value]="sched.percent * 100 | clamp: 0 : 100"
				class="with-back-spinner"
				strokeWidth="3"
			></mat-progress-spinner>
		</div>
	</div>
</ng-template>
<ng-template
	#scheduleTooltip
	let-sched
>
	<div class="mat-typography flex flex-col px-3 py-2.5">
		<div class="flex items-center space-x-2">
			<span>{{ sched.name || ('schedules.name' | translate) }}</span>
			<ng-container *ngIf="sched.percent >= 0">
				<span class="dot size-1.5"></span>
				<span>{{ sched.percent | percent }}</span>
			</ng-container>
		</div>
	</div>
</ng-template>
<ng-template #recordingText>
	<div class="text-warn flex items-center space-x-1 leading-none animate-pulse">
		<span class="dot mat-bg-5! size-1.5"></span>
		<span class="text-warn animate-pulse font-medium">{{ 'time.recording' | translate }}</span>
	</div>
</ng-template>
<ng-template
	#confirmDeleteDialog
	let-data="dialogData"
	let-ref="dialogRef"
>
	<div
		class="mat-dialog-title-base flex flex-col"
		matDialogTitle
	>
		<h4 class="my-0">{{ 'utils.confirmDeletion' | translate }}</h4>
	</div>
	<mat-dialog-content> <p>{{ 'comego.confirmDeleteAllEntries' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
		<button
			(click)="ref.close(true)"
			color="warn"
			mat-stroked-button
		>
			{{ 'utils.deleteAllEntries' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>
<ng-template
	#whErrorTooltip
	let-errors="errors"
>
	<div class="flex flex-col space-y-2">
		<div
			*ngFor="let werr of errors"
			class="flex items-start space-x-2"
		>
			<div class="dot mt-1.5 mat-size-1.5"></div>
			<div>{{ werr.message | translate: (werr.args | translateArgs) }}</div>
		</div>
	</div>
</ng-template>
